export default {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    critical: '#d42f77',
    caution: '#f7c744',
    positive: '#408728',
    neutral: '#747474',
    info: '#274788',
    promote: '#8c5bb2',
    success: ['#c6f7d4', '#21543d', '#38a169'],
    danger: ['#f8d7d9', '#731c23', '#e53e3e'],
    warning: ['#fff3cd', '#866407', '#f7bd45'],
    muted: ['#e2e3e5', '#65696d', '#acacac'],
    dark: ['#d5d8d9', '#1b1f22', '#004466'],
    light: ['#fefefe', '#818182', '#f8f9fb'],
    default: ['#edf2f6', '#1a212c', '#718096'],
    gray: [
      '#f7fafc',
      '#edf2f7',
      '#e2e8f0',
      '#cbd5e0',
      '#a0aec0',
      '#718096',
      '#4a5568',
      '#2d3748',
      '#1a202c',
    ],
    red: [
      '#fff5f5',
      '#fed7d7',
      '#feb2b2',
      '#fc8181',
      '#f56565',
      '#e53e3e',
      '#c53030',
      '#9b2c2c',
      '#742a2a',
    ],
    orange: [
      '#fffaf0',
      '#feebc8',
      '#fbd38d',
      '#f6ad55',
      '#ed8936',
      '#dd6b20',
      '#c05621',
      '#9c4221',
      '#7b341e',
    ],
    yellow: [
      '#fffff0',
      '#fefcbf',
      '#faf089',
      '#f6e05e',
      '#ecc94b',
      '#d69e2e',
      '#b7791f',
      '#975a16',
      '#744210',
    ],
    green: [
      '#f0fff4',
      '#c6f6d5',
      '#9ae6b4',
      '#68d391',
      '#48bb78',
      '#38a169',
      '#2f855a',
      '#276749',
      '#22543d',
    ],
    teal: [
      '#e6fffa',
      '#b2f5ea',
      '#81e6d9',
      '#4fd1c5',
      '#38b2ac',
      '#319795',
      '#2c7a7b',
      '#285e61',
      '#234e52',
    ],
    blue: [
      '#ebf8ff',
      '#bee3f8',
      '#90cdf4',
      '#63b3ed',
      '#4299e1',
      '#3182ce',
      '#2b6cb0',
      '#2c5282',
      '#2a4365',
    ],
    indigo: [
      '#ebf4ff',
      '#c3dafe',
      '#a3bffa',
      '#7f9cf5',
      '#667eea',
      '#5a67d8',
      '#4c51bf',
      '#434190',
      '#3c366b',
    ],
    purple: [
      '#faf5ff',
      '#e9d8fd',
      '#d6bcfa',
      '#b794f4',
      '#9f7aea',
      '#805ad5',
      '#6b46c1',
      '#553c9a',
      '#44337a',
    ],
    pink: [
      '#fff5f7',
      '#fed7e2',
      '#fbb6ce',
      '#f687b3',
      '#ed64a6',
      '#d53f8c',
      '#b83280',
      '#97266d',
      '#702459',
    ],
  },
  fontSizes: [12, 14, 16, 20, 24, 32],
  fontWeights: ['300', '400', '500', '600', '700'],
  space: [0, 2, 4, 8, 12, 16, 20, 24, 28, 32],
};
